/**
 * Merge a submit response back into `orderData` (SOF-3402/SOF-3439).
 *
 * `vulcanSubmitPayload` is a raw axios PUT/POST — `response.data` is whatever
 * the SERVER's response body happens to contain, entirely outside client
 * control. If it doesn't echo back every field that was just submitted, the
 * naive `{ ...orderData, ...response.data }` silently drops it from client
 * state — nothing errors, the field just reads back empty later.
 *
 * Real-data bug: a MultiCheckbox field ("Products to add") correctly saved
 * (confirmed: the exact same save-payload builders round-trip the selected
 * array unchanged) but reverted to unchecked after Continue-ing forward a
 * step and clicking Back. Pre-migration this was masked — the legacy
 * `formFields` React state persisted across step navigation (the step-owning
 * component never unmounted) and `normalizedFields` only ever populated a
 * field `!Object.prototype.hasOwnProperty.call(result, key)` — i.e. it never
 * overwrote a field that already had a live value, so a gap in the server's
 * echo was invisible. `VulcanFormStepRunner`'s engine has no such
 * protection: `useFormRunner` unmounts and fully re-seeds `values` from
 * `initialValues` (`orderData`) on every step transition (formStepVulcan.js's
 * `isLoading` gate swaps it for a loader and back), so any gap in the
 * server's response is now directly visible.
 *
 * `formData` — what the client JUST submitted — is folded in as a fallback
 * BEFORE `response.data`, so the server's response still wins on any key it
 * actually returns; this only fills in what it stayed silent on.
 *
 * @param {Object} orderData    Current client-side order state
 * @param {Object} formData     The payload just submitted (buildEngineFormData)
 * @param {Object} [responseData]  `response.data` from the submit call
 * @returns {Object}
 */
export const mergeOrderDataAfterSubmit = (
  orderData,
  formData,
  responseData
) => ({
  ...orderData,
  ...formData,
  ...responseData
});

export default mergeOrderDataAfterSubmit;
